module.exports = __webpack_public_path__ + "img/checkmark_green.768f5fcb.svg";